import { useEffect } from 'react';

import { useCommonStore } from '@/store';

export const usePaymentsConfig = () => {
  const isAuthenticated = useCommonStore.use.isAuthenticated();
  const user = useCommonStore.use.user();

  useEffect(() => {
    if (!isAuthenticated) return;
    window.PaymentsAPI?.resetCache().then(() => {
      console.log('resetCache');
    });
  }, [isAuthenticated, user]);
};
